import React from 'react';
export function ContactSection() {
  return <footer className="border-t border-ivory/15 bg-ink px-5 pb-7 pt-14 sm:px-8 lg:px-12 lg:pb-8 lg:pt-20" data-id="element-5" data-mp="1j32uigqrei9s">
      <div className="mx-auto max-w-[1600px]" data-id="element-6" data-mp="2zampvk1uc8sn">
        <div className="max-w-3xl" data-id="element-7" data-mp="2kkf52xod2dos">
          <p className="text-lg font-light leading-relaxed text-ivory/65 sm:text-xl" data-id="element-8" data-mp="2klgsm1mkcsne">
            <span className="font-medium text-ivory" data-id="element-9" data-mp="2pj9wgo0e9aki">Get in touch</span> for technology
            partnerships, co-production opportunities, or further information
            regarding the production.
          </p>
          <a href="mailto:dop2026live@gmail.com" className="mt-6 inline-block border-b border-sage/50 pb-2 text-sm tracking-[0.12em] text-ivory transition-colors duration-500 hover:border-sage hover:text-sage focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-sage" data-id="element-10" data-mp="3i6mh2smzv8b6">
            dop2026live@gmail.com
          </a>
        </div>

        <div className="mt-14 border-t border-ivory/10 pt-5" data-id="element-11" data-mp="1wuunai3y1mh3">
          <p className="text-[10px] uppercase tracking-[0.22em] text-ivory/35" data-id="element-12" data-mp="7lmt8a928ja8">
            © Improbable Arts
          </p>
        </div>
      </div>
    </footer>;
}